angular.module("acl.common.tabSwitcher", []);
